module.exports = {"mobile_number":"Mobiltelefonnummer","enter_mobile_number":"Gib deine Mobiltelefonnummer ein","invalid":"Die eingegebene Mobiltelefonnummer scheint nicht ganz korrekt zu sein"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/phone.json
// module id = 496
// module chunks = 248 1677